import axios from 'axios';

// 서비스 기본 설정
const serviceOption = {
  baseURL: `${process.env.VUE_APP_API_URL}/intro/api/`, // 기본 호출 경로
  timeout: 5000, // 타임아웃 설정
  transformRequest: (data) => JSON.stringify(data || {}),
  withCredentials: true, // 보안 쿠키 허용
  headers: {
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache',
    'Pragma': 'no-cache',
    'Expires': '0',
  },
  data: {},
};

const service = axios.create(serviceOption);

service.interceptors.request.use(
  (config) => config,
  (error) => {
    console.log(error);
    return Promise.reject(error);
  },
);

service.interceptors.response.use(
  (response) => response,
  (error) => {
    console.log(error);
    return Promise.reject(error.response);
  },
);

export default service;
